<template>
  <div class="mb-200">
    <div class="mb-75">
      <h3 class="list_heading">{{ heading }}</h3>
      <p v-if="description" class="list_description">{{ description }}</p>
    </div>

    <slot></slot>
  </div>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "StepListSection",
  props: {
    heading: {
      type: String,
      required: true,
    },
    description: {
      type: String,
    }
  },
})
</script>

<style scoped lang="scss">
.list_heading {
  font-size: 1.125rem;
  font-weight: bold;
}

.list_description {
  margin-top: 6px;
  font-size: 0.875rem;
  line-height: 1.3
}

.item_label {
  min-width: 210px;
  padding-left: 10px;
}
</style>
